<template>
	<el-dialog
		:title="$t('commonInfo.productInfo')"
		:visible.sync="visible"
		width="800px"
		append-to-body
	>
		<el-table v-loading="loading" :data="productList" border style="width: 100%">
			<el-table-column prop="companyProductCode" label="商品编码" align="center" min-width="150" />
			<el-table-column prop="productAmount" label="数量" align="center" min-width="100" />
			<el-table-column prop="skuNew" label="换标新SKU" align="center" min-width="150" />
			<el-table-column prop="swapCnt" label="换标数量" align="center" min-width="100" />
		</el-table>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose">{{$t('commonInfo.dialogBtnCancel')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'CheckProduct',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		rowData: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			loading: false,
			productList: []
		};
	},
	watch: {
		visible(val) {
			if (val) {
				this.loadData();
			}
		},
	},
	methods: {
		loadData() {
			this.loading = true;
			this.productList = this.rowData.skuList || [];
			this.loading = false;
		},
		handleClose() {
			this.$emit('update:visible', false);
		}
	}
};
</script>

<style scoped>
.dialog-footer {
	text-align: center;
}
</style>